import classNames from "classnames";

import AlarmIcon from "../../assets/images/alarm-icon2.svg";
import LockIcon from "../../assets/images/lock-icon2.svg";
import ShieldIcon from "../../assets/images/shield-icon2.svg";

import style from "./ChargebeeTrialTimeline.module.css";

interface ChargebeeTrialTimelineProps {
  trialDays: number;
}

const ChargebeeTrialTimeline = ({ trialDays }: ChargebeeTrialTimelineProps) => {
  return (
    <div className={classNames(style.timelineWrapper)}>
      <div className={style.horizontalLines}>
        <div></div>
        <div className={style.lineItem}></div>
        <div className={style.lineItem}></div>
        <div></div>
      </div>
      <div className={style.timelineItem}>
        <img src={LockIcon} />
        <div className={style.title}>Today</div>
        <div className={style.text}>
          Add credit card details and get instant access to all features without limits.
        </div>
      </div>

      <div className={style.timelineItem}>
        <img src={AlarmIcon} />
        <div className={style.title}>{trialDays - 2 < 3 ? "Tomorrow" : `Day ${trialDays - 2}`}</div>
        <div className={style.text}>Get a reminder email that your free trial will end.</div>
      </div>

      <div className={style.timelineItem}>
        <img src={ShieldIcon} />
        <div className={style.title}>Day {trialDays}</div>
        <div className={style.text}>{`You will be charged. Cancel anytime before.`}</div>
      </div>
    </div>
  );
};

export default ChargebeeTrialTimeline;
